import { Controller } from 'stimulus';
import Colcade from 'colcade';

export default class extends Controller {
  connect() { 
    console.log('masonry');
    const colc = new Colcade(this.element, {
      columns: '.masonry-col',
      items: '.project-card',
    })
  }
}
